<div  class="loading-indicator" *ngIf="global.afterloginspinner">
    <mat-progress-spinner    mode="indeterminate" ></mat-progress-spinner>
  </div>
<router-outlet   ></router-outlet>